(function ($) {

    "use strict";

    var Carousel = function (el, options) {
        this.$wrapper = $(el);
        this.$inner = $(el).find('.carousel-inner');
        this.options = options;
        this.init();
    };

    Carousel.prototype = {
        init: function ()
        {
            this.appendOptions();
            this.getItems();
            this.cloneItems();
        },
        // appendeo las opciones enviadas desde la vista
        appendOptions: function ()
        {
            var self = this;
            $.each(this.options, function(k, v) {
                self[k] = v; // this.options.foo = this.foo
            });
        },
        getItems: function () {
            this.$items = this.$inner.find('.carousel-item');
            this.normalizeItemsLength();
        },
        normalizeItemsLength: function () {
            var self = this;
            if (this.$items.length < this.maxItems) {
                $.each(this.$items, function() {
                    var $clone = $(this).clone().removeClass('active');
                    self.$inner.append($clone);
                });
                this.getItems();
            }
        },
        cloneItems: function () {
            var self = this;
            $.each(this.$items, function(){
                var $itemToClone = $(this);

                for (var i = 1; i < self.maxItems; i++) {
                    $itemToClone = $itemToClone.next();

                    // wrap around if at end of item collection
                    if (!$itemToClone.length) {
                        $itemToClone = $(this).siblings(':first');
                    }

                    // grab item, clone, add marker class, add to collection
                    $itemToClone.children(':first-child').clone()
                        .addClass("cloneditem-"+(i))
                        .appendTo($(this));
                }
            });
        },
    };

    /* Wrapper de jQuery */
    $.fn.MultiCarousel = function (options) {
        return this.each(function () {
            var data = $(this).data('lb.carousel');
            if ( ! data) {
                $(this).data(
                    'lb.carousel', // namespace LB
                    (data = new Carousel(this, $.extend({}, $.fn.MultiCarousel.defaults, options)))
                );
            }
        });
    };

    /* Default options */
    $.fn.MultiCarousel.defaults = {
        maxItems: 12
    };

}(jQuery));